import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { JPPreset } from './jpdesign-preset';

export const primeNGConfig = {
  theme: {
    preset: JPPreset,
    options: {
      darkModeSelector: false,
      cssLayer: {
        name: 'primeng',
        order: 'tailwind-base, primeng, tailwind-utilities',
      },
    },
  },
  ripple: true,
  inputStyle: 'outlined' as const,
  zIndex: {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200,
  },
  translation: {
    accept: 'Ano',
    reject: 'Ne',
    choose: 'Vybrat',
    upload: 'Nahrát',
    cancel: 'Zrušit',
    completed: 'Dokončeno',
    pending: 'Čekající',
    dayNames: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
    dayNamesShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
    dayNamesMin: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
    monthNames: [
      'Leden',
      'Únor',
      'Březen',
      'Duben',
      'Květen',
      'Červen',
      'Červenec',
      'Srpen',
      'Září',
      'Říjen',
      'Listopad',
      'Prosinec',
    ],
    monthNamesShort: [
      'Led',
      'Úno',
      'Bře',
      'Dub',
      'Kvě',
      'Čer',
      'Čvc',
      'Srp',
      'Zář',
      'Říj',
      'Lis',
      'Pro',
    ],
    chooseYear: 'Vybrat rok',
    chooseMonth: 'Vybrat měsíc',
    chooseDate: 'Vybrat datum',
    prevDecade: 'Předchozí desetiletí',
    nextDecade: 'Následující desetiletí',
    prevYear: 'Předchozí rok',
    nextYear: 'Následující rok',
    prevMonth: 'Předchozí měsíc',
    nextMonth: 'Následující měsíc',
    prevHour: 'Předchozí hodina',
    nextHour: 'Následující hodina',
    prevMinute: 'Předchozí minuta',
    nextMinute: 'Následující minuta',
    prevSecond: 'Předchozí sekunda',
    nextSecond: 'Následující sekunda',
    am: 'dop',
    pm: 'odp',
    today: 'Dnes',
    weekHeader: 'Týd',
    firstDayOfWeek: 1,
    dateFormat: 'dd.mm.yy',
    weak: 'Slabé',
    medium: 'Střední',
    strong: 'Silné',
    passwordPrompt: 'Zadejte heslo',
    emptyFilterMessage: 'Nebyly nalezeny žádné výsledky',
    searchMessage: 'Dostupných {0} výsledků',
    selectionMessage: 'Vybráno {0} položek',
    emptySelectionMessage: 'Není vybrána žádná položka',
    emptySearchMessage: 'Nebyly nalezeny žádné výsledky',
    emptyMessage: 'Nejsou dostupné žádné možnosti',
    clear: 'Vymazat',
    apply: 'Použít',
    matchAll: 'Spárovat vše',
    matchAny: 'Spárovat jakékoliv',
    addRule: 'Přidat pravidlo',
    removeRule: 'Odebrat pravidlo',
    startsWith: 'Začíná s',
    contains: 'Obsahuje',
    notContains: 'Neobsahuje',
    endsWith: 'Končí s',
    equals: 'Rovná se',
    notEquals: 'Nerovná se',
    noFilter: 'Bez filtru',
    lt: 'Menší než',
    lte: 'Menší nebo rovno',
    gt: 'Větší než',
    gte: 'Větší nebo rovno',
    dateIs: 'Datum je',
    dateIsNot: 'Datum není',
    dateBefore: 'Datum je před',
    dateAfter: 'Datum je po',
    aria: {
      trueLabel: 'Pravda',
      falseLabel: 'Nepravda',
      nullLabel: 'Nevybráno',
      star: '1 hvězda',
      stars: '{star} hvězd',
      selectAll: 'Všechny položky vybrány',
      unselectAll: 'Všechny položky zrušeny',
      close: 'Zavřít',
      previous: 'Předchozí',
      next: 'Následující',
      navigation: 'Navigace',
      scrollTop: 'Posunout nahoru',
      moveTop: 'Přesunout nahoru',
      moveUp: 'Přesunout nahoru',
      moveDown: 'Přesunout dolů',
      moveBottom: 'Přesunout dolů',
      moveToTarget: 'Přesunout k cíli',
      moveToSource: 'Přesunout ke zdroji',
      moveAllToTarget: 'Přesunout vše k cíli',
      moveAllToSource: 'Přesunout vše ke zdroji',
      pageLabel: '{page}',
      firstPageLabel: 'První stránka',
      lastPageLabel: 'Poslední stránka',
      nextPageLabel: 'Následující stránka',
      prevPageLabel: 'Předchozí stránka',
      rowsPerPageLabel: 'Řádků na stránku',
      jumpToPageDropdownLabel: 'Přeskočit na stránku Dropdown',
      jumpToPageInputLabel: 'Přeskočit na stránku Input',
      selectRow: 'Řádek vybrán',
      unselectRow: 'Řádek zrušen',
      expandRow: 'Řádek rozbalen',
      collapseRow: 'Řádek sbalen',
      showFilterMenu: 'Zobrazit menu filtru',
      hideFilterMenu: 'Skrýt menu filtru',
      filterOperator: 'Operátor filtru',
      filterConstraint: 'Omezení filtru',
      editRow: 'Upravit řádek',
      saveEdit: 'Uložit úpravu',
      cancelEdit: 'Zrušit úpravu',
      listView: 'Zobrazení seznamu',
      gridView: 'Zobrazení mřížky',
      slide: 'Snímek',
      slideNumber: '{slideNumber}',
      zoomImage: 'Přiblížit obrázek',
      zoomIn: 'Přiblížit',
      zoomOut: 'Oddálit',
      rotateRight: 'Otočit doprava',
      rotateLeft: 'Otočit doleva',
    },
  },
};

export const uiProviders = [providePrimeNG(primeNGConfig), MessageService];
